import { TransportType } from "@syla/shared/types/helpers/TransportType";
import {
  SyncState,
  FileImportState,
} from "@syla/shared/types/models/WalletBase";
import { UpdateWalletResponse } from "@syla/shared/types/responses/UpdateWalletResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export interface UpdateWalletBody {
  apiKey?: string;
  secretKey?: string;
  passphrase?: string;
  customName?: string;
  syncState?: SyncState;
  fileImportState?: FileImportState | null;
  fromDate?: Date;
}

export async function updateWallet(
  accountId: string,
  walletId: string,
  newProps: UpdateWalletBody,
): Promise<UpdateWalletResponse> {
  try {
    const response = await axios.patch<TransportType<UpdateWalletResponse>>(
      `/accounts/${accountId}/wallets/${walletId}`,
      newProps,
    );
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
